import React from "react";

const ASP_File = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP File</h1>
      <p>This is the ASP File page content.</p>
    </div>
  );
};

export default ASP_File;
